import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import EditIcon from "@mui/icons-material/Edit";
import { getFormattedNumber } from "../../utils/textUtils";
import PaginationDataTable from "../../Common/PaginationDataTable";
import { RECIPE_URL } from "../../../CONSTANTS";

const RecipeList = (props) => {
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState("");
    const [rows, setRows] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(0);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                name: "NAME",
                selector: (row) => row.itemTitle,
                style: { color: "#007bff" },
            },
            {
                name: "QUANTITY",
                selector: (row) => getFormattedNumber(row.quantity) + " " + row.quantityUnitTitle,
            },
            {
                name: "ACTION",
                selector: (row) => (
                    <div>
                        <EditIcon
                            style={{ fontSize: "15px", cursor: "pointer" }}
                            onClick={() => {
                                navigate("/recipe/" + row.recordId + "/edit");
                            }}
                        />
                    </div>
                ),
            },
        ], [handleRefresh]
    )

    const handleRowClick = (row) => {
        if (props.onRowClicked) {
            props.onRowClicked(row);
        }
        const recordId = row.recordId;
        if (recordId) {
            navigate(`/recipe/${recordId}`);
        }
    };

    const handleClickNew = () => {
        navigate('/recipe/new');
    };

    useEffect(() => {
        const result = rows.filter((data) => {
            return data.itemTitle.toLowerCase().includes(search.toLowerCase());
        });
        setFilteredData(result);
    }, [search]);

    return (
        <>
            <div style={{ height: 500, width: "100%" }}>
                <PaginationDataTable
                    paginationUrl={
                        RECIPE_URL() + "getAllRecords"
                    }
                    serverSidePagination={true}
                    search={true}
                    pagination={false}
                    columns={columns}
                    onRowClicked={handleRowClick}
                    onNewClicked={handleClickNew}
                />
            </div>
            <Toaster />
        </>
    );
};

export default RecipeList;
